module.exports = __webpack_public_path__ + "static/media/Prepare-Pretest-01.8ace3f50.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/Prepare-Pretest-01.mp3
// module id = 545
// module chunks = 0